import { Button, styled } from '@mui/material';
import StyledLoadingButton from './LoadingButton';

type ButtonProps = {
  onClick: () => void;
  children: string;
  loading?: boolean;
  loadingText?: string;
  fullWidth?: boolean;
  disabled?: boolean;
};

const CommonButton = styled(Button)(() => ({
  color: '#FFFFFF',
  borderRadius: '15px',
  border: '1px solid var(--Alert-Sunset-Orange, #FF9A9A)',
  background: 'var(--Alert-Sunset-Orange, linear-gradient(175deg, #FF9A9A -9.81%, #FF5858 96.32%))',
  padding: '16px 32px !important',
  '&:hover': {
    background:
      'linear-gradient(175deg, rgba(255, 154, 154, 0.8) -9.81%, rgba(255, 88, 88, 0.8) 96.32%)',
  },
}));

function StyledDeleteButton({
  onClick,
  children,
  loading,
  loadingText,
  fullWidth = true,
  disabled,
}: ButtonProps) {
  return !loading ? (
    <CommonButton
      type="submit"
      variant="contained"
      fullWidth={fullWidth}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </CommonButton>
  ) : (
    <StyledLoadingButton fullWidth={fullWidth}>{loadingText || children}</StyledLoadingButton>
  );
}

export default StyledDeleteButton;
